module.exports = __webpack_public_path__ + "img/intranet.53122dfb.svg";